/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualTaxDto } from '../../models/backend-actual-tax-dto';

export interface MonitoringActualsTaxesCopyCreate$Params {
  id: number;
}

export function monitoringActualsTaxesCopyCreate(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsTaxesCopyCreate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualTaxDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsTaxesCopyCreate.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualTaxDto>;
    }),
  );
}

monitoringActualsTaxesCopyCreate.PATH = '/api/monitoring/actuals/taxes/copy/{id}/';
